<template>
  <d-row
    :id="id"
    :class="{
      'pax-list w-100 mt-4 ml-0 mr-0': true,
      'is-loading': !allDataLoaded,
      'save-in-progress': orderSaveInProgress
    }">
    <fieldset class="w-100 mb-0">
      <legend>{{ title }}</legend>

      <d-row
        v-if="allDataLoaded"
        class="ml-0 mr-0 mb-4 mt-2">
        <d-col
          cols="3"
          :class="{
            'ml-0 pl-0': true,
            'mt-4': manualDocumentSet
          }">
          <v-select
            :options="itemsToSelect"
            v-model="selected_item"
            :reduce="item => item.id"
            :placeholder="'Select a ' + this.type"
            label="id"
            :maxItemsDisplay="100"
            :filterBy="filterByName">
            <template slot="no-options">
              <template>There are no items to display&hellip;</template>
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.first_name }} {{ option.last_name }} <template v-if="option.passports_count > 1">({{ option.passports_count }})</template>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.first_name }} {{ option.last_name }} <template v-if="option.passports_count > 1">({{ option.passports_count }})</template>
              </div>
            </template>
          </v-select>

          <d-checkbox
            v-model="manualDocumentSet"
            class="mt-2">
            <small>Manual arrival/departure documents set</small>
          </d-checkbox>
        </d-col>

        <d-col
          cols="3">
          <template v-if="manualDocumentSet">
            <small class="text-primary">
              Departure document:
            </small>

            <v-select
              :options="documents"
              v-model="selected_departure_document"
              :reduce="item => item.id"
              placeholder="Select a departure document"
              label="id"
              :disabled="!(selected_item && loadedDocuments)"
              :filterable="false">
              <template slot="no-options">
                <template>There are no documents&hellip;</template>
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center text-nowrap">
                  <template v-if="option.type === 'Passport'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(departureAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                  <template v-else-if="option.type === 'Visa'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else-if="option.type === 'License'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.country }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(departureAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center text-nowrap selected-option-block">
                  <template v-if="option.type === 'Passport'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(departureAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                  <template v-else-if="option.type === 'Visa'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else-if="option.type === 'License'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.country }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(departureAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                </div>
              </template>
            </v-select>

            <small class="text-success">
              Arrival document:
            </small>

            <v-select
              :options="documents"
              v-model="selected_arrival_document"
              :reduce="item => item.id"
              placeholder="Select an arrival document"
              label="id"
              :disabled="!(selected_item && loadedDocuments)"
              :filterable="false">
              <template slot="no-options">
                <template>There are no documents&hellip;</template>
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center text-nowrap">
                  <template v-if="option.type === 'Passport'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(arrivalAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                  <template v-else-if="option.type === 'Visa'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else-if="option.type === 'License'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.country }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(arrivalAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center text-nowrap selected-option-block">
                  <template v-if="option.type === 'Passport'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(arrivalAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                  <template v-else-if="option.type === 'Visa'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else-if="option.type === 'License'">
                    <small class="text-success"><strong>{{ option.type }}</strong></small><br>
                    {{ option.name }} - {{ option.country }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                  </template>
                  <template v-else>
                    {{ option.name }} - {{ option.nationality }}<br>
                    <small>Exp: {{ option.expiry }} | Serial no.:{{ option.serial_number }}</small>
                    <span
                      v-if="option.countries.map(country => country.id).indexOf(arrivalAirportCountryId) > -1"
                      class="is-recommended">
                      <i class="material-icons">star</i>
                    </span>
                  </template>
                </div>
              </template>
            </v-select>
          </template>
        </d-col>

        <d-col
          cols="2">
          <d-checkbox
            v-if="selected_item !== null && (!manualDocumentSet || (manualDocumentSet && selected_arrival_document !== null && selected_departure_document !== null))"
            inline
            v-model="apply_to_entire_trip"
            toggle-small>
            <small>Apply to entire trip</small>
          </d-checkbox>
        </d-col>

        <d-col
          cols="4"
          class="text-right">
          <d-button
            v-if="selected_item !== null && (!manualDocumentSet || (manualDocumentSet && selected_arrival_document !== null && selected_departure_document !== null))"
            outline
            theme="success"
            class="w-25 mr-2"
            :disabled="addInProgress"
            @click.prevent="addItem">
            Add {{ this.type }}
          </d-button>

          <d-button
            theme="warning"
            :outline="true"
            class="ml-auto w-25"
            @click.prevent="importItems">
            Import
          </d-button>

          <d-button
            theme="success"
            class="ml-2 w-25"
            @click.prevent="$bus.$emit('add-' + type + '-popup-show')">
            Add new
          </d-button>
        </d-col>
      </d-row>

      <d-row
        v-if="allDataLoaded && id === 'passengers'"
        class="ml-0 mr-0 mb-4 mt-2 d-flex">
        <d-col cols="3" class="align-middle pt-1 pl-0">
          Number of TBC passengers:
        </d-col>
        <d-col cols="2">
          <d-input
            class="input-type-for-firefox"
            type="number"
            min="0"
            step="1"
            v-model="tbc_count" />
        </d-col>
        <d-button
          @click.prevent="addTbcItems"
          theme="success"
          outline>
          Update TBC count
        </d-button>
      </d-row>

      <table class="table">
        <thead>
          <tr>
            <th class="px-0" style="width: 30px;"></th>
            <th>Name</th>
            <th>DOB</th>
            <th>Nationality</th>
            <th>Doc type</th>
            <th>Serial number</th>
            <th>Expiry</th>
            <th>Actions</th>
          </tr>
        </thead>
        <draggable
          v-model="items"
          tag="tbody">
          <tr
            v-for="(item, index) of items"
            :key="'item-' + index">
            <td class="text-center align-middle cursor-move px-0"><i class="material-icons dnd-icon">dehaze</i></td>
            <td class="align-middle">{{ item[type + '_first_name'] }} {{ item[type + '_last_name'] }} </td>
            <td class="align-middle">{{ item[type + '_birth_date'] | formatDateToUK }}</td>
            <td class="align-middle">
              <small class="text-primary">Departure document</small>
              <span class="d-block">{{ item[type + '_document_nationality'] }}</span>

              <small class="text-success">Arrival document</small>
              <span class="d-block mb-2">{{ item['arrival_' + type + '_document_nationality'] }}</span>
            </td>
            <td class="align-middle">
              <small class="text-primary">Departure document</small>
              <span class="d-block">{{ item[type + '_document_type'] }}</span>

              <small class="text-success">Arrival document</small>
              <span class="d-block mb-2">{{ item['arrival_' + type + '_document_type'] }}</span>
            </td>
            <td class="align-middle">
              <small class="text-primary">Departure document</small>
              <span class="d-block">{{ item[type + '_document_number'] }}</span>

              <small class="text-success">Arrival document</small>
              <span class="d-block mb-2">{{ item['arrival_' + type + '_document_number'] }}</span>
            </td>
            <td class="align-middle">
              <small class="text-primary">Departure document</small>
              <span :class="{
                'd-block': true,
                'mb-2': true,
                'text-warning': dateHasWarningState(item[type + '_document_expiry']),
                'text-danger': dateHasDangerState(item[type + '_document_expiry'])
              }">
                {{ item[type + '_document_expiry'] | ddmmmyyyyFormat }}
              </span>

              <small class="text-success">Arrival document</small>
              <span :class="{
                'd-block': true,
                'mb-2': true,
                'text-warning': dateHasWarningState(item[type + '_document_expiry']),
                'text-danger': dateHasDangerState(item['arrival_' + type + '_document_expiry'])
              }">
                {{ item['arrival_' + type + '_document_expiry'] | ddmmmyyyyFormat }}
              </span>
            </td>
            <td class="align-middle">
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.prevent="removeItem(item.id)"
                title="Remove">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>

          <tr
            v-for="(n, index) in tbcCountToDisplay"
            :key="'tbc-item-' + n + '-' + index">
            <td
              class="align-middle"
              colspan="7">
              TBC
            </td>
          </tr>
        </draggable>
      </table>

      <d-row hidden class="mt-5 mb-4 ml-0 mr-0">
        <d-col cols="4">
          Hotels for:
          <a :href="baseUrl + '/dashboard/airports/' + departureAirportId" target="_blank" class="text-primary">
            {{ departureAirport }}
          </a>
        </d-col>

        <d-col cols="2">
          <d-checkbox
            inline
            v-model="departure_hotels_not_required"
            toggle
            toggle-small>
            not required
          </d-checkbox>
        </d-col>
      </d-row>

      <fieldset :class="{ 'w-100 mt-5 mb-2': true }">
        <legend>Hotels</legend>

        <d-row class="m-1">
          <d-col cols="4">
            Hotels for:
            <a :href="baseUrl + '/dashboard/airports/' + arrivalAirportId" target="_blank" class="text-primary">
              {{ arrivalAirport }}
            </a>
          </d-col>

          <d-col cols="2">
            <d-checkbox
              inline
              v-model="arrival_hotels_not_required"
              toggle
              toggle-small>
              not required
            </d-checkbox>
          </d-col>

          <d-textarea
            v-if="!arrival_hotels_not_required"
            v-model="hotel_desc"
            :value.prop="hotel_desc"
            :rows="3" />
        </d-row>
      </fieldset>

      <transport
        :departureAirport="departureAirport"
        :departureAirportId="departureAirportId"
        :arrivalAirport="arrivalAirport"
        :arrivalAirportId="arrivalAirportId"
        :referenceId="referenceId"
        :departureTransportNotRequired="departureTransportNotRequired"
        :arrivalTransportNotRequired="arrivalTransportNotRequired"
        :type="type" />
    </fieldset>
  </d-row>
</template>

<script>
import DateUtils from './../../utils/DateUtils.js';
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';
import Transport from './Transport.vue';
import debounce from 'lodash.debounce';
import vueDraggable from 'vuedraggable';
import Vue from 'vue';

export default {
  name: 'pax-list',
  props: [
    'id',
    'title',
    'customerId',
    'loadPassengersItems',
    'loadCrewItems',
    'departureAirport',
    'departureAirportId',
    'departureAirportCountryId',
    'arrivalAirport',
    'arrivalAirportId',
    'arrivalAirportCountryId',
    'referenceId',
    'departureHotelsNotRequired',
    'arrivalHotelsNotRequired',
    'departureTransportNotRequired',
    'arrivalTransportNotRequired',
    'type',
    'tbcCount'
  ],
  components: {
    'draggable': vueDraggable,
    'transport': Transport
  },
  filters: {
    formatDateToUK (input) {
      if (!input) {
        return '';
      }

      return input.split('-').reverse().join(' / ');
    },
    ddmmmyyyyFormat (value) {
      if (value) {
        let input = new Date(value);

        return [
          input.getDate(),
          DateUtils.getMonthShortName(input.getMonth() + 1),
          input.getFullYear().toString().substr(2, 2)
        ].map(n => n < 10 ? '0' + n : n).join('');
      }

      return '';
    }
  },
  computed: {
    allDataLoaded () {
      return this.loadedCrew && this.loadedPassengers && this.loadedItems;
    },
    baseUrl () {
      return window.location.protocol + '//' + window.location.host;
    },
    itemsToSelect () {
      let crew = [];
      let passengers = [];

      if (this.loadCrewItems) {
        crew = this.crew.map(item => {
          item.type = 'CREW';
          item.id = item.type + ';' + item.id;
          return item;
        });
      }

      if (this.loadPassengersItems) {
        passengers = this.passengers.map(item => {
          item.type = 'PASSENGER';
          item.id = item.type + ';' + item.id;
          return item;
        });
      }

      return crew.concat(passengers);
    }
  },
  data () {
    return {
      crew: [],
      passengers: [],
      documents: [],
      loadedCrew: false,
      loadedPassengers: false,
      loadedDocuments: false,
      loadedItems: false,
      selected_item: null,
      apply_to_entire_trip: false,
      selected_arrival_document: null,
      selected_departure_document: null,
      items: [],
      addInProgress: false,
      removeInProgress: false,
      hotel_desc: '',
      departure_hotels_not_required: false,
      arrival_hotels_not_required: false,
      departure_transport_not_required: false,
      arrival_transport_not_required: false,
      tbc_count: 0,
      tbcCountToDisplay: [],
      orderSaveInProgress: false,
      setupComplete: false,
      manualDocumentSet: false
    };
  },
  watch: {
    selected_item (newValue, oldValue) {
      if (newValue !== oldValue && !!newValue) {
        this.loadedDocuments = false;
        this.loadDocuments();
      }
    },
    departure_hotels_not_required (newValue) {
      let field = 'crew_departure_hotels';

      if (this.type === 'passenger') {
        field = 'passengers_departure_hotels';
      }

      this.$bus.$emit('flight-form-not-required-update', field, newValue);
    },
    arrival_hotels_not_required (newValue) {
      let field = 'crew_arrival_hotels';

      if (this.type === 'passenger') {
        field = 'passengers_arrival_hotels';
      }

      this.$bus.$emit('flight-form-not-required-update', field, newValue);
    },
    allDataLoaded (newValue) {
      if (newValue) {
        Vue.nextTick(() => {
          this.setupComplete = true;
        });
      }
    },
    items: {
      'handler': function (newValue, oldValue) {
        if (this.setupComplete && this.items.length > 0) {
          this.debouncedSaveOfOrdering();
        }

        if (this.type === 'passenger' && newValue.length !== oldValue.length) {
          this.$bus.$emit('flight-item-update-pax-number', newValue.length);
        }
      },
      deep: true
    },
    tbc_count (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$bus.$emit('flight-item-update-tbc-count', newValue);
      }
    },
    hotel_desc (newValue) {
      let field = 'crew_hotel';

      if (this.type === 'passenger') {
        field = 'passengers_hotel';
      }

      this.$bus.$emit('flight-form-hotel-update', field, newValue);
    }
  },
  mounted () {
    if (this.loadPassengersItems) {
      this.loadPassengers();
    } else {
      this.loadedPassengers = true;
    }

    if (this.loadCrewItems) {
      this.loadCrew();
    } else {
      this.loadedCrew = true;
    }

    this.departure_hotels_not_required = !!this.departureHotelsNotRequired;
    this.arrival_hotels_not_required = !!this.arrivalHotelsNotRequired;
    this.departure_transport_not_required = !!this.departureTransportNotRequired;
    this.arrival_transport_not_required = !!this.arrivalTransportNotRequired;

    if (this.id === 'passengers') {
      this.tbc_count = this.tbcCount;
      this.tbcCountToDisplay = Array.from({ length: this.tbcCount }, (_, i) => i + 1);
    }

    this.loadItems();
    this.$bus.$on('pax-list-reload-needed', this.loadItems);
    this.$bus.$on('pax-list-passengers-reload-needed', this.loadPassengers);
    this.$bus.$on('pax-list-crews-reload-needed', this.loadCrew);
    this.$bus.$on('pax-list-reload-arrival-hotels', this.reloadArrivalHotels);
    this.$bus.$on('pax-list-reload-departure-hotels', this.reloadDepartureHotels);
    this.$bus.$on('pax-list-passengers-hotel', this.updatePaxHotel);
    this.$bus.$on('pax-list-crew-hotel', this.updateCrewHotel);
    this.$bus.$on('pax-list-add-item-with-document', this.addItemWithDocument);
  },
  methods: {
    loadItems () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/trips/' + this.type + 's/items',
        params: {
          where: {
            flight_id: this.referenceId
          },
          pagination: 0
        },
        loadedKey: 'loadedItems',
        outputKey: 'items',
        errorKey: 'loadError'
      });
    },
    loadCrew () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/crews/items',
        params: {
          pagination: 0,
          where: {
            flight_customer_id: this.customerId
          }
        },
        loadedKey: 'loadedCrew',
        outputKey: 'crew',
        errorKey: 'loadError'
      });
    },
    loadPassengers () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/passengers/items',
        params: {
          pagination: 0,
          where: {
            flight_customer_id: this.customerId
          }
        },
        loadedKey: 'loadedPassengers',
        outputKey: 'passengers',
        errorKey: 'loadError'
      });
    },
    filterByName (option, label, search) {
      return (option.first_name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    filterByItemName (option, label, search) {
      return (option[this.type + '_first_name'] + ' ' + option[this.type + '_last_name']).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    filterByHotelName (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    loadDocuments () {
      this.loadedDocuments = false;

      if (this.selected_item === null) {
        return;
      }

      let type = this.selected_item.split(';')[0];
      let id = parseInt(this.selected_item.split(';')[1], 10);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/passports/items',
        params: {
          pagination: 0,
          where: {
            reference_id: id,
            reference_type: type
          }
        },
        loadedKey: 'loadedDocuments',
        outputKey: 'documents',
        errorKey: 'loadError'
      });
    },
    addItem () {
      this.addInProgress = true;
      let id = parseInt(this.selected_item.split(';')[1], 10);
      let type = this.selected_item.split(';')[0];

      if (!this.manualDocumentSet && !this.getDocumentField('arrival', 'serial_number')) {
        this.addInProgress = false;

        Vue.swal({
          title: 'Error!',
          html: 'Cannot automatically select document for this person. Please do it manually.',
          icon: 'error',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });

        return;
      }

      let dataToAdd = {
        flight_id: parseInt(this.referenceId, 10),
        [this.type + '_id']: id,
        ['arrival_' + this.type + '_document_type']: 'Passport',
        ['arrival_' + this.type + '_document_country_id']: this.getDocumentField('arrival', 'country_id'),
        ['arrival_' + this.type + '_document_number']: this.getDocumentField('arrival', 'serial_number'),
        ['arrival_' + this.type + '_document_expiry']: this.getDocumentField('arrival', 'expiry'),
        [this.type + '_document_type']: 'Passport',
        [this.type + '_document_country_id']: this.getDocumentField('departure', 'country_id'),
        [this.type + '_document_number']: this.getDocumentField('departure', 'serial_number'),
        [this.type + '_document_expiry']: this.getDocumentField('departure', 'expiry'),
        apply_to_entire_trip: this.apply_to_entire_trip
      };

      if (this.type === 'crew') {
        delete dataToAdd[this.type + '_id'];
        dataToAdd['person_id'] = id;
        dataToAdd['person_type'] = type;
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/trips/' + this.type + 's/store',
        formData: dataToAdd,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during adding item. Please try again.',
        successAction: (response) => {
          if (response.success === 0) {
            Vue.swal({
              title: 'Error!',
              html: response.errors.join(', '),
              icon: 'error',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          } else {
            Vue.swal({
              title: 'Success',
              html: this.type + ' has been successfully added',
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true,
              timer: 1000,
              timerProgressBar: true
            });
          }

          this.selected_item = null;
          this.selected_arrival_document = null;
          this.selected_departure_document = null;
          this.apply_to_entire_trip = false;
          this.addInProgress = false;
          this.loadItems();
        }
      });
    },
    importItems () {
      this.$bus.$emit('show-import-pax-items-popup', {
        itemType: this.type + 's',
        flightID: this.referenceId
      });
    },
    removeItem (itemID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/trips/' + this.type + 's/delete/',
        id: itemID,
        successTitle: 'Item removed',
        successText: 'The selected item has been removed',
        confirmTitle: 'Do you really want to remove this item?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadItems();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    getDocumentField (documentType, field) {
      if (this.manualDocumentSet) {
        let foundedDocument = this.documents.filter(document => document.id === this['selected_' + documentType + '_document'])[0];

        if (!foundedDocument) {
          return false;
        }

        return foundedDocument[field];
      }

      if (this.documents.length === 1) {
        return this.documents[0][field];
      }

      if (this.documents.length === 0) {
        return false;
      }

      let countryPassports = this.documents.filter(document => document.countries.map(country => country.id).indexOf(this[documentType + 'AirportCountryId']) > -1);
      let defaultDocument = this.documents.filter(document => document.is_default)[0];

      if (countryPassports.length === 1) {
        return countryPassports[0][field];
      }

      if (countryPassports.length === 0 && defaultDocument) {
        return defaultDocument[field];
      }

      if (countryPassports.length > 1) {
        let defaultCountryPassport = countryPassports.filter(document => document.is_default)[0];

        if (!defaultCountryPassport) {
          return false;
        }

        return defaultCountryPassport[field];
      }

      if (!defaultDocument) {
        return false;
      }

      return defaultDocument[field];
    },
    addNote (field, item) {
      this.$bus.$emit('show-note-popup', 'add', field, item);
    },
    editNote (field, item) {
      this.$bus.$emit('show-note-popup', 'edit', field, item);
    },
    dateHasWarningState (date) {
      date = +new Date(date);

      if (date - +new Date() < 180 * 24 * 60 * 60 * 1000 && date - +new Date() > 14 * 24 * 60 * 60 * 1000) {
        return true;
      }

      return false;
    },
    dateHasDangerState (date) {
      date = +new Date(date);

      if (date - +new Date() < 14 * 24 * 60 * 60 * 1000 || +new Date() > date) {
        return true;
      }

      return false;
    },
    addTbcItems () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/trips/flights/update-tbc-count/' + parseInt(this.referenceId, 10),
        formData: {
          tbc_count: this.tbc_count
        },
        successTitle: 'TBC items added',
        successText: 'The TBC items has been successfully added!',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          Vue.set(this, 'tbcCountToDisplay', Array.from({ length: this.tbc_count }, (_, i) => i + 1));
          this.loadItems();
        }
      });
    },
    updatePaxHotel (newValue) {
      if (this.type === 'passenger') {
        Vue.set(this, 'hotel_desc', newValue);
      }
    },
    updateCrewHotel (newValue) {
      if (this.type === 'crew') {
        Vue.set(this, 'hotel_desc', newValue);
      }
    },
    // eslint-disable-next-line
    debouncedSaveOfOrdering: debounce(function () {
      this.saveItemsOrder();
    }, 1000),
    saveItemsOrder () {
      let dataType = 'passengers';

      if (this.type === 'crew') {
        dataType = 'crews';
      }

      this.orderSaveInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/trips/' + dataType + '/update-ordering',
        formData: {
          items: this.items.map(item => item.id),
          flight_id: this.referenceId
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during ordering change. Please try again.',
        successAction: () => {
          this.orderSaveInProgress = false;
        }
      });
    },
    addItemWithDocument (payload) {
      if (this.type !== payload.itemType.toLowerCase()) {
        return;
      }

      this.addInProgress = true;

      let dataToAdd = {
        flight_id: parseInt(this.referenceId, 10),
        [this.type + '_id']: payload.itemID,
        ['arrival_' + this.type + '_document_type']: 'Passport',
        ['arrival_' + this.type + '_document_country_id']: payload.documentData.country_id,
        ['arrival_' + this.type + '_document_number']: payload.documentData.serial_number,
        ['arrival_' + this.type + '_document_expiry']: payload.documentData.expiry,
        [this.type + '_document_type']: 'Passport',
        [this.type + '_document_country_id']: payload.documentData.country_id,
        [this.type + '_document_number']: payload.documentData.serial_number,
        [this.type + '_document_expiry']: payload.documentData.expiry,
        apply_to_entire_trip: false
      };

      if (this.type === 'crew') {
        delete dataToAdd[this.type + '_id'];
        dataToAdd['person_id'] = payload.itemID;
        dataToAdd['person_type'] = payload.itemType;
      }

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/trips/' + this.type + 's/store',
        formData: dataToAdd,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during adding item. Please try again.',
        successAction: () => {
          Vue.swal({
            title: 'Success',
            html: this.type + ' has been successfully added',
            icon: 'success',
            confirmButtonText: 'OK',
            buttonsStyling: true,
            timer: 1000,
            timerProgressBar: true
          });

          this.selected_item = null;
          this.selected_arrival_document = null;
          this.selected_departure_document = null;
          this.apply_to_entire_trip = false;
          this.addInProgress = false;
          this.loadItems();
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('pax-list-reload-needed', this.loadItems);
    this.$bus.$off('pax-list-reload-arrival-hotels', this.reloadArrivalHotels);
    this.$bus.$off('pax-list-reload-departure-hotels', this.reloadDepartureHotels);
    this.$bus.$off('pax-list-passengers-hotel', this.updatePaxHotel);
    this.$bus.$off('pax-list-crew-hotel', this.updateCrewHotel);
    this.$bus.$off('pax-list-passengers-reload-needed', this.loadPassengers);
    this.$bus.$off('pax-list-crews-reload-needed', this.loadCrew);
    this.$bus.$off('pax-list-add-item-with-document', this.addItemWithDocument);
  }
}
</script>

<style lang="scss" scoped>
.pax-list {
  &.save-in-progress {
    &:before {
      content: "Save in progress...";
    }
  }

  &.is-loading,
  &.save-in-progress {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }

  .text-nowrap {
    white-space: nowrap;
  }

  .selected-option-block {
    font-size: 80%;
    line-height: 1;
  }

  *:has(.is-recommended) {
    position: relative;
  }

  .is-recommended {
    color: orange;
    font-size: 20px;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
